export default __webpack_public_path__ + "static/media/chrome-logo.cc429424.png";